import { render, staticRenderFns } from "./u-tit-wrap-underline.vue?vue&type=template&id=1481bc96&scoped=true&"
import script from "./u-tit-wrap-underline.vue?vue&type=script&lang=js&"
export * from "./u-tit-wrap-underline.vue?vue&type=script&lang=js&"
import style0 from "./u-tit-wrap-underline.vue?vue&type=style&index=0&id=1481bc96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481bc96",
  null
  
)

export default component.exports